"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LobDataResponseMapper = void 0;
var LobDataResponseMapper = /** @class */ (function () {
    function LobDataResponseMapper(data) {
        this.localData = data;
    }
    LobDataResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return LobDataResponseMapper;
}());
exports.LobDataResponseMapper = LobDataResponseMapper;
//# sourceMappingURL=LobDataResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/LobDataResponseMapper.js
// module id = 2078
// module chunks = 8